import React from "react";
import styled from "styled-components";

const Root = styled.div`
  width: fit-content;
  border-radius: ${props => (props.shape === "circle" ? "50%" : 0)};
  border: ${props => (props.shape === "circle" ? "1px solid" : "0")};
  border-color: ${props => props.color || props.theme.colors.primary.white};
  padding: ${props => props.padding || "1.8rem 1.4rem"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: ${props => props.margin || "0"};
  background-color: ${props => props.backgroundColor};
  
  svg {
    fill: ${props => props.color || props.theme.colors.primary.white};
  }

  &:hover {
    border-color: ${props =>
      props.hoverColor || props.theme.colors.primary.green};
    svg {
      fill: ${props => props.hoverColor || props.theme.colors.primary.green};
    }
  }
`;

export const IconButton = ({ shape, children, icon, ...restProps }) => {
  return (
    <Root shape={shape} {...restProps}>
      {!!icon && icon}
      {children}
    </Root>
  );
};
